import { MapOptions } from '../../../../../core/types/types';

export const drawOptions = (
    isDrawPolygonActive: boolean,
    distanceBetweenGeneratedPoints: number | undefined,
    mapOptions: MapOptions,
) => {
    // if (isDrawPolygonActive) {
    return isDrawPolygonActive
        ? {
              rectangle: false,
              polyline: false,
              polygon: {
                  showLength: true,
                  showArea: true,
                  metric: true,
                  allowIntersection: false,
                  shapeOptions: {
                      color: distanceBetweenGeneratedPoints ? 'orange' : '',
                      fillOpacity: distanceBetweenGeneratedPoints ? 0 : '',
                  },
              },
              circle: false,
              circlemarker: false,
              marker: false,
          }
        : {
              rectangle: false,
              polyline: mapOptions.tools.drawPolyline
                  ? {
                        showLength: true,
                        metric: true,
                        allowIntersection: false,
                    }
                  : false,
              polygon: mapOptions.tools.drawPolygon
                  ? {
                        showLength: true,
                        showArea: true,
                        metric: true,
                        allowIntersection: false,
                    }
                  : false,
              circle: false,
              circlemarker: false,
              marker: false,
              edit: { edit: false },
          };
};
// else {
//     return {
//         rectangle: false,
//         polyline: {
//             showLength: true,
//             allowIntersection: false,
//             shapeOptions: {
//                 guidelineDistance: 10,
//                 color: 'red',
//                 weight: 3,
//             },
//         },
//         polygon: false,
//         circle: false,
//         circlemarker: false,
//         marker: true,
//     };
// }
